export default "__VITE_ASSET__CSSCE3IA__"